// extracted by mini-css-extract-plugin
export var arrow = "ExpertTalksModal-module--arrow--d106e";
export var closeButton = "ExpertTalksModal-module--closeButton--a9da1";
export var closeIcon = "ExpertTalksModal-module--closeIcon--86f5d";
export var container = "ExpertTalksModal-module--container--2dae5";
export var controls = "ExpertTalksModal-module--controls--e116a";
export var fadeInAnimation = "ExpertTalksModal-module--fadeInAnimation--283f3";
export var next = "ExpertTalksModal-module--next--def14";